export const isChrome = true // !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
export function smallScreen() {
    return window.screen.width <= 600
}
export function screenWidth() {
    return window.screen.width
}
export function moveToTop() {
    window.scrollTo({
        behavior: 'smooth',
        top: 0
    })
}